export const branchAddresses = {
  "chennai-anna-nagar": {
    address:
      "Level 3, VR Chennai, Jawaharlal Nehru Road, Anna Nagar, Chennai, Tamil Nadu, India",
    netSize: 15500,
    grossSize: 25800,
    floors: 1,
  },
  "chennai-omr": {
    address:
      "SRP Stratford, Old Mahabalipuram Road (OMR), Perungudi, Chennai, Tamil Nadu, India",
    netSize: 95000,
    grossSize: 158000,
    floors: 1,
  },
  "chennai-skcl-guindy": {
    address: "SKCL Guindy, Chennai, Tamil Nadu, India",
    netSize: 25000,
    grossSize: 42000,
    floors: 1,
  },
  "chennai-porur": {
    address:
      "Level 3, Keppel One Paramount, Mount Poonamallee Road, Porur, Chennai, Tamil Nadu 600116, India",
    netSize: 20000,
    grossSize: 33000,
    floors: 1,
  },
  "bangalore-whitefield": {
    address: "ITPL Main Road, Whitefield, Bangalore, Karnataka, India",
    netSize: 48000,
    grossSize: 80000,
    floors: 1,
  },
  "bangalore-ptp": {
    address: "Prestige Tech Platina, Bangalore, Karnataka, India",
    netSize: 30000,
    grossSize: 50000,
    floors: 1,
  },
  "hyderabad-gachibowli": {
    address:
      "Corporate Capital, Financial District, next to Sheraton Hyderabad Hotel, Gachibowli, Hyderabad, Telangana, India",
    netSize: 45000,
    grossSize: 75000,
    floors: 1,
  },
  "pune-mills": {
    address:
      "The Mills at RBCC, Raja Bahadur Mill Road, behind Sheraton Grand Hotel, Sangamwadi, Pune, Maharashtra, India",
    netSize: 35000,
    grossSize: 58000,
    floors: 1,
  },
};


